/**
 * Geografía de Guatemala e idiomas de los clientes.
 */
/**
 * Los 22 departamentos de Guatemala, en el orden de código del RENAP (01–22),
 * con el número de municipios de cada uno. El orden importa: los dígitos
 * 10–11 del DPI (CUI) son el código de departamento y los 12–13 el del
 * municipio.
 */
export const DEPARTMENTS = [
    { code: '01', name: 'Guatemala', municipalities: 17 },
    { code: '02', name: 'El Progreso', municipalities: 8 },
    { code: '03', name: 'Sacatepéquez', municipalities: 16 },
    { code: '04', name: 'Chimaltenango', municipalities: 16 },
    { code: '05', name: 'Escuintla', municipalities: 14 },
    { code: '06', name: 'Santa Rosa', municipalities: 14 },
    { code: '07', name: 'Sololá', municipalities: 19 },
    { code: '08', name: 'Totonicapán', municipalities: 8 },
    { code: '09', name: 'Quetzaltenango', municipalities: 24 },
    { code: '10', name: 'Suchitepéquez', municipalities: 21 },
    { code: '11', name: 'Retalhuleu', municipalities: 9 },
    { code: '12', name: 'San Marcos', municipalities: 30 },
    { code: '13', name: 'Huehuetenango', municipalities: 33 },
    { code: '14', name: 'Quiché', municipalities: 21 },
    { code: '15', name: 'Baja Verapaz', municipalities: 8 },
    { code: '16', name: 'Alta Verapaz', municipalities: 17 },
    { code: '17', name: 'Petén', municipalities: 14 },
    { code: '18', name: 'Izabal', municipalities: 5 },
    { code: '19', name: 'Zacapa', municipalities: 11 },
    { code: '20', name: 'Chiquimula', municipalities: 11 },
    { code: '21', name: 'Jalapa', municipalities: 7 },
    { code: '22', name: 'Jutiapa', municipalities: 17 },
];
/** Códigos de departamento como tupla no vacía (para `z.enum`). */
export const DEPARTMENT_CODES = DEPARTMENTS.map((d) => d.code);
/** Nombre del departamento para un código, o `undefined` si no existe. */
export function departmentName(code) {
    return DEPARTMENTS.find((d) => d.code === code)?.name;
}
/**
 * Idiomas que hablan los clientes. El crédito rural suele explicarse en el
 * idioma materno del cliente, así que los asesores lo registran para asignar
 * las visitas.
 */
export const CLIENT_LANGUAGES = [
    'es', 'kiche', 'qeqchi', 'kaqchikel', 'mam', 'tzutujil', 'poqomchi', 'achi', 'ixil',
    'qanjobal', 'chuj', 'popti', 'akateko', 'awakateko', 'chorti', 'garifuna', 'xinka', 'other',
];
/** Idioma por defecto de un cliente nuevo: español. */
export const DEFAULT_CLIENT_LANGUAGE = 'es';
/** Nombre para mostrar de cada idioma. */
export const CLIENT_LANGUAGE_LABELS = {
    es: 'Español',
    kiche: "K'iche'",
    qeqchi: "Q'eqchi'",
    kaqchikel: 'Kaqchikel',
    mam: 'Mam',
    tzutujil: "Tz'utujil",
    poqomchi: "Poqomchi'",
    achi: 'Achi',
    ixil: 'Ixil',
    qanjobal: "Q'anjob'al",
    chuj: 'Chuj',
    popti: "Popti'",
    akateko: 'Akateko',
    awakateko: 'Awakateko',
    chorti: "Ch'orti'",
    garifuna: 'Garífuna',
    xinka: 'Xinka',
    other: 'Otro',
};
//# sourceMappingURL=geography.js.map